<template>

    <div class="row">
        <!-- Nome -->
        <div class="col-md-4">
            <div class="form-group">
                <label for="userName">
                    <span class="required">*</span>
                    Nome
                </label>
                <input
                    :disabled="disabledFields && disabledFields.name"
                    type="text"
                    class="form-control"
                    id="userName"
                    :value="value.name"
                    @input="updateField('name', $event.target.value)"
                />
            </div>
        </div>

        <!-- Matrícula -->
        <div class="col-md-4">
            <div class="form-group">
                <label for="userMatriculation">
                    <span class="required">*</span>
                    Matrícula
                </label>
                <input
                    :disabled="disabledFields && disabledFields.matriculation"
                    type="text"
                    class="form-control"
                    id="userMatriculation"
                    :value="value.matriculation"
                    @input="updateField('matriculation', $event.target.value)"
                />
            </div>
        </div>

        <!-- RG -->
        <div class="col-md-4">
            <div class="form-group">
                <label for="userRG">
                    <span class="required">*</span>
                    RG
                </label>
                <input
                    :disabled="disabledFields && disabledFields.rg"
                    type="text"
                    class="form-control"
                    id="userRG"
                    v-mask="'##.###.###-#'"
                    :value="value.rg"
                    @input="updateField('rg', $event.target.value)"
                />
            </div>
        </div>

        <!-- CPF -->
        <div class="col-md-4">
            <div class="form-group">
                <label for="userCPF">
                    <span class="required">*</span>
                    CPF
                </label>
                <input
                    :disabled="disabledFields && disabledFields.cpf"
                    type="text"
                    class="form-control"
                    id="userCPF"
                    v-mask="'###.###.###-##'"
                    :value="value.cpf"
                    @input="updateField('cpf', $event.target.value)"
                />
            </div>
        </div>

        <!-- Data de Nascimento -->
        <div class="col-md-4">
            <div class="form-group">
                <label for="userDateOfBirth">
                    <span class="required">*</span>
                    Data de Nascimento
                </label>
                <input
                    :disabled="disabledFields && disabledFields.date_of_birth"
                    type="text"
                    class="form-control"
                    id="userDateOfBirth"
                    v-mask="'##/##/####'"
                    :value="value.date_of_birth"
                    @input="updateField('date_of_birth',$event.target.value)"
                />
            </div>
        </div>

        <!-- Data de Admissão -->
        <div class="col-md-4">
            <div class="form-group">
                <label for="userAdmissionDate">
                    <span class="required">*</span>
                    Data de Admissão
                </label>
                <input
                    :disabled="disabledFields && disabledFields.admission_date"
                    type="text"
                    class="form-control"
                    id="userAdmissionDate"
                    v-mask="'##/##/####'"
                    :value="value.admission_date"
                    @input="updateField('admission_date',$event.target.value)"
                />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'UserBasicInfo',
    props: {
        value: {
            type: Object,
            required: true
        },
        disabledFields: {
            type: Object,
            required: false,
            default: () => {}
        }
    },
    methods: {
        updateField(field, value) {
            this.$emit('update', field, value);
        },
    }
};
</script>



// WEBPACK FOOTER //
// src/components/User/form-components/UserBasicInfo.vue